require('../../modules/es6.string.ends-with');
module.exports = require('../../modules/_core').String.endsWith;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/fn/string/ends-with.js
// module id = 846
// module chunks = 9